export const domainMap = {
	'nexplan.pro': 'nexplan',
	'www.nexplan.pro': 'nexplan',
	'testapp.nexplan.pro': 'nexplan',
	'www.testapp.nexplan.pro': 'nexplan',
	'nexplan.ru': 'nexplan',
	'www.nexplan.ru': 'nexplan',
	'app.nexplan.pro': 'nexplan',
	'www.app.nexplan.pro': 'nexplan',
	'lynkora.ru': 'lynkora',
	'www.lynkora.ru': 'lynkora',
	'app.lynkora.ru': 'lynkora',
	'www.app.lynkora.ru': 'lynkora',
	'testapp.lynkora.ru': 'lynkora',
	'www.testapp.lynkora.ru': 'lynkora',
	'localhost': 'lynkora',
	'127.0.0.1': 'nexplan'
}

export function getSiteName() {
	if (typeof window === 'undefined') {
		return 'nexplan'
	}
	return 'nexplan'; //domainMap[window.location.hostname] || 'nexplan'
}

export const columnsTypes = {
	"IDEA": 187,
	"BACKLOG": 188,
	"READY": 189,
	"IN_PROGRESS": 190,
	"PAUSED": 191,
	"REVIEW": 192,
	"DONE": 193,
	"CANCELED": 194
}

export const priorityValues = [
	{ value: 0, class: "np-inactive", bg: "#ebebeb", color: "#262626", label: 'UI.task.priority_0' },
	{ value: 1, class: "np-crimson", bg: "#FECACA", color: "#991B1B", label: 'UI.task.priority_1' },
	{ value: 2, class: "np-amber", bg: "#FEF08A", color: "#854D0E", label: 'UI.task.priority_2' },
	{ value: 3, class: "np-success", bg: "#BBF7D0", color: "#166534", label: 'UI.task.priority_3' },
	{ value: 4, class: "np-freeze", bg: "#BFDBFE", color: "#1E40AF", label: 'UI.task.priority_4' }
]

export const columnsColors      = [ '#3B82F6', '#DE4A85', '#A855F7', '#EAB308', '#F97316', '#22C55E' ]
export const columnsColorsLight = [ '#93C5FD', '#ec6b9f', '#be85f3', '#FEF08A', '#FDBA74', '#75f7a2' ]

// API my-tasks отдаёт пользователя как { id, name, avatar }, CobaltProfile ожидает { first_name, last_name, imageFile }
export function mapApiUser(user) {
	const parts = (user?.name || '').trim().split(/\s+/)
	return {
		first_name: parts[0] || '',
		last_name:  parts.slice(1).join(' '),
		imageFile:  user?.avatar || null
	}
}

export function formatDate(date) {
	const options = { year: 'numeric', month: 'long', day: 'numeric' }
	const d = new Date(date)
	return d.toLocaleDateString(undefined, options) + " " + d.toLocaleTimeString(undefined, options)
}

export function localeTime(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute:'2-digit'})
	} else {
		return ""
	}
}
	
export function localeDate(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleDateString('ru-RU')
	} else {
		return ""
	}
}

export function localeDateTime(timestamp) {
	if (timestamp) {
		const d = new Date(timestamp * 1000)
		return d.toLocaleDateString('ru-RU') + " " + d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute:'2-digit'})
	} else {
		return ""
	}
}
	
export function serialize(obj) {
	var str = []
	for (var p in obj)
	if (obj.hasOwnProperty(p)) {
		str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
	}
	return str.join("&")
}

export function lightenDarkenColor(col, amt) {
  const usePound = col[0] === '#';
  const hex = usePound ? col.slice(1) : col;

  // Парсим RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Нормализуем amt в диапазон [-1, 1] (amt теперь в процентах: 20 = 20%)
  const factor = Math.min(1, Math.max(-1, amt / 100));
  
  let newR, newG, newB;
  if (factor >= 0) {
    // Осветление: смешиваем с белым
    newR = Math.round(r + (255 - r) * factor);
    newG = Math.round(g + (255 - g) * factor);
    newB = Math.round(b + (255 - b) * factor);
  } else {
    // Затемнение: смешиваем с чёрным
    const f = Math.abs(factor);
    newR = Math.round(r * (1 - f));
    newG = Math.round(g * (1 - f));
    newB = Math.round(b * (1 - f));
  }

  const toHex = c => c.toString(16).padStart(2, '0');
  const result = `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
  return usePound ? result : result.slice(1);
}

export function eventDate(timestamp) {

	var date = new Date(timestamp * 1000)
	var aaaa = date.getFullYear()
	var gg = date.getDate()
	var mm = (date.getMonth() + 1)

	if (gg < 10)
		gg = "0" + gg

	if (mm < 10)
		mm = "0" + mm

	var cur_day = aaaa + "-" + mm + "-" + gg

	var hours = date.getHours()
	var minutes = date.getMinutes()

	if (hours < 10)
		hours = "0" + hours

	if (minutes < 10)
		minutes = "0" + minutes

	return cur_day + " " + hours + ":" + minutes
}

export function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function cleanHtmlText(html, options = {}) {
	if (!html) return ''

	const div = document.createElement('div')
	div.innerHTML = html

	div.querySelectorAll('script, style').forEach(el => el.remove())

	div.querySelectorAll('br, p, div').forEach(el => {
		const textContent = el.textContent || ''
		const spaceOrNewline = options.preserveNewLines && (el.tagName === 'P' || el.tagName === 'DIV') ? '\n' : ' '
		el.replaceWith(document.createTextNode(textContent + spaceOrNewline))
	})

	if (!options.keepLinks) {
		div.querySelectorAll('a').forEach(a => {
			a.replaceWith(document.createTextNode(` ${a.textContent} `))
		})
	}

	let text = div.textContent || div.innerText || ''

	text = text.trim()

	if (options.preserveNewLines) {
		text = text.replace(/[ \t]+\n/g, '\n').replace(/\n[ \t]+/g, '\n')
		text = text.replace(/\n{3,}/g, '\n\n')
	} else {
		text = text.replace(/\s+/g, ' ').trim()
	}

	if (options.maxLength && text.length > options.maxLength) {
		text = text.substring(0, options.maxLength)
		const lastSpace = text.lastIndexOf(' ')
		if (lastSpace > 0) {
			text = text.substring(0, lastSpace)
		}
		text += '...'
	}

	return text
}

export function convertSeconds(seconds, format = 'string') {
	const days = Math.floor(seconds / 86400)
	seconds %= 86400
	
	const hours = Math.floor(seconds / 3600)
	seconds %= 3600
	
	const minutes = Math.floor(seconds / 60)
	seconds %= 60
	
	// Функция для добавления лидирующего нуля
	const pad = (num) => num.toString()//.padStart(2, '0')
	
	if (format === 'string') {
		const parts = []
		if (days > 0) parts.push(`${days}:`)
		parts.push(`${pad(hours)}:${pad(minutes)}:${pad(seconds)}s`)
		return parts.join('')
	} else if (format === 'object') {
		return { 
		"days": pad(days), 
		"hours": pad(hours), 
		"minutes": pad(minutes), 
		"seconds": pad(seconds) 
		}
	} else {
		throw new Error('Invalid format. Use "object" or "string".')
	}
}

export function getExtension(filename) {
	if (!filename || typeof filename !== 'string') return ''

	const trimmed = filename.trim()
	const lastDotIndex = trimmed.lastIndexOf('.')

	if (lastDotIndex <= 0 || lastDotIndex === trimmed.length - 1) {
		return ''
	}

	return trimmed.slice(lastDotIndex + 1).toLowerCase()
}

export function nameColor(str) {
  if (!str || typeof str !== 'string') return '#E8E8E8';

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = hash >>> 0;
  hash ^= hash >> 16;

  const hue = hash % 360;
  const saturation = 40 + ((hash >> 10) & 15);
  const lightness = 70 + ((hash >> 14) & 10);

  return hslToHex(hue, saturation, lightness);
}

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;
  let r, g, b;
  
  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];

  const toHex = n => Math.round((n + m) * 255).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function hexToRgba(hex, alpha = 1) {
  hex = hex.replace('#', '');
  
  if (alpha > 1) {
    alpha = alpha / 100;
  }
  
  alpha = Math.max(0, Math.min(1, alpha));
  
  let r, g, b;
  
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else if (hex.length === 8) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    const hexAlpha = parseInt(hex.substring(6, 8), 16) / 255;
    alpha = alpha * hexAlpha;
  } else {
    throw new Error('Wrong HEX colors');
  }
  
  return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`;
}